import { takeEvery, fork, put, all, call } from "redux-saga/effects";

//Account Redux states
import { REGISTER_USER } from "../../constants/actionTypes";
import {
  registerUserSuccessful,
  registerUserFailed,
} from "../../actions/authentication";

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../helpers/firebase_helper";
import { createUser } from "../../api/user";

// initialize relavant method of both Auth
const fireBaseBackend = getFirebaseBackend();

// Is user register successfull then direct plot user in redux.
function* registerUser({ payload: { user } }) {
  let authUser = null;

  try {
    // Step 1: Create Firebase Authentication user
    authUser = yield call(
      fireBaseBackend.registerUser,
      user.email,
      user.password
    );

    try {
      // Step 2: Create user record in database
      yield call(createUser, user);

      // Registration complete - update Redux state
      yield put(registerUserSuccessful(authUser));
      window.location.reload();
    } catch (dbError) {
      // Step 3: If database record creation fails, rollback auth user
      if (authUser) {
        yield call(fireBaseBackend.deleteAuthUser, authUser);
        console.log(
          "Auth user deleted due to database record creation failure"
        );
      }

      // Forward the error for display
      throw new Error("Registration failed: Could not create user record");
    }
  } catch (error) {
    // Clean up session if needed
    yield call(fireBaseBackend.logout);
    yield put(registerUserFailed(error.message || error));
  }
}

export function* watchUserRegister() {
  yield takeEvery(REGISTER_USER, registerUser);
}

function* accountSaga() {
  yield all([fork(watchUserRegister)]);
}

export default accountSaga;
